/** Fairfield LGA-style suburb list for child seat / events address capture. */
export const FAIRFIELD_SUBURBS = [
  "Abbotsbury",
  "Bonnyrigg",
  "Bonnyrigg Heights",
  "Bossley Park",
  "Cabramatta",
  "Cabramatta West",
  "Canley Heights",
  "Canley Vale",
  "Carrama",
  "Cecil Park",
  "Edensor Park",
  "Fairfield",
  "Fairfield East",
  "Fairfield Heights",
  "Fairfield West",
  "Greenfield Park",
  "Horsley Park",
  "Lansvale",
  "Mt Pritchard",
  "Old Guildford",
  "Prairiewood",
  "St Johns Park",
  "Smithfield",
  "Villawood",
  "Wakeley",
  "Wetherill Park",
  "Yennora",
].sort((a, b) => a.localeCompare(b));

/** O(1) membership for form validation */
export const FAIRFIELD_SUBURB_SET = new Set(FAIRFIELD_SUBURBS);

export const CHILD_SEAT_COUNT_OPTIONS = [
  { label: "1", value: 1 },
  { label: "2", value: 2 },
  { label: "3", value: 3 },
];

const SUBURB_SELECT_OPTIONS = FAIRFIELD_SUBURBS.map((s) => ({ label: s, value: s }));

export function suburbSelectOptions() {
  return SUBURB_SELECT_OPTIONS;
}
